import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Florida">
                                <h1>Expert Software Development Company in <span>Florida</span></h1>
                            </div>
                            <p className="main_para">Build turnkey products, solutions, and technical services for key stakeholders, customers, and employees with our growth-centric software development company in Florida which prioritizes creativity and innovation.</p>
                            <Link to="/contact"
                            className="border_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;